<template>
	<div>
		<van-search class="base_search" v-bind="$attrs" v-on="$listeners">
			<template #left-icon>
				<img class="left_icon" src="../../../assets/icon/search.png" />
			</template>
		</van-search>
	</div>
</template>
<script>
export default {
    name: 'baseSearch',

}
</script>
<style lang="less" scoped>
.base_search {
	padding: 12px 32px 8px 32px;
}
.left_icon {
	width: 36px;
	height: 36px;
}
</style>
<style lang="less">
.base_search {
	.van-field__left-icon {
		display: flex;
		align-items: center;
	}
	.van-search__content {
		border-radius: 20px;
		background-color: #eff0f1;
		.van-field {
			padding: 16px 20px 16px 0;
			font-size: 28px;
		}
	}
}
</style>